module.exports = __webpack_public_path__ + "static/media/image-not-found.dd0e6166.png";